/* eslint-disable no-unused-expressions */
import setAsRead from 'app/_shared/events/message/setAsRead'

/**
 * Returns the payload used to assign the ticket to the current user.
 *
 * @type QuickPayload
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {?Gaia.PlatformEvent} event optional event for the quick action
 * @returns {Object}
 */
export default async (module, component, event) => {
  await setAsRead(module, component, null)

  return {
    value: {
      statusReason: 0,
    },
  }
}
